import { CalendarColumnBodyVariant, CalendarEventType } from './types';

export const MIN_COLUMN_WIDTH: Record<CalendarColumnBodyVariant, number> = {
  stacked: 50,
  grid: 200,
};

export const CALENDAR_Z_INDICES = {
  topCornerCell: 100, // above all other cells
  groupHeader: 90,
  timeColumn: 80,
  currentTimeIndicatorBadge: 85,
  currentTimeIndicatorLine: 75,
};

export const EVENT_Z_INDICES: Record<CalendarEventType, number> = {
  unavailableBlock: 30,
  availableBlock: 30,
  exception: 30,
  scheduleDefinition: 40,
  // events
  appointment: 50,
  scheduleRequest: 50,
  cancelledAppointment: 50,
  // other
  availabilitySlot: 60,
  nonInteractiveSlot: 60,
  slotsStartLabel: 60,
};

export const PX_PER_MINUTE = 2; // 1 minute = 2px, so 15 minutes = 30px
export const TOTAL_HOURS = 24;
